
import * as moment from 'moment'

// リクエストポスト
const MAIN_TYPE = 'apollo_request_post'

// カテゴリー名
const CATEGORY_NAME = '面接関連'

// 面接データから取得する項目
const ITEM = [
  // 登録日
  'createDate',
  // 採否
  'interviewsResult',
  // 一次面接合否
  'firstInterviewRes',
  // 性別
  'interviewsSex',
  // 辞退
  'declineReason'
]


/**
 * 一覧取得
 * @param {*} context
 * @returns
 */
export async function getList(
  context,
  filter,
  perPage,
  page
) {
  const find = {}

  // ステータス
  find.status = { $ne: 'remove' }
  if (filter.status === '完了済み') {
    find.status = 'done'
  } else if (filter.status === '未完了') {
    find.status = 'open'
  }

  // タイプ
  find.type = MAIN_TYPE

  // カテゴリ
  find.category = CATEGORY_NAME

  // 作成日
  if (filter.start || filter.end) {
    find.createDate = {}
    if (filter.start) {
      find.createDate.$gte = filter.start
    }
    if (filter.end) {
      const end = moment(filter.end).add(1, 'days').format('YYYY-MM-DD')
      find.createDate.$lte = end
    }
  }

  // 新卒
  if (filter.title === 'newGrad') {
    find.interviewsRegularStaff = true
    find.newGrad = true

  // 中卒
  } else if (filter.title === 'mid') {
    find.interviewsRegularStaff = true
    find.newGrad = { $ne: true }

  // 清掃員
  } else if (filter.title === 'cleaner') {
    find.interviewsRegularStaff = { $ne: true }
  }

  // 採否
  if (filter.res && filter.res != '採否全て') {
    // 辞退以外の場合はこれが必要
    const notDec = [
      { declineReason: { $exists: false } },
      { declineReason: '' },
      { declineReason: null }
    ]

    // 未定の時
    const notRes = [
      { interviewsResult: { $exists: false } },
      { interviewsResult: null },
      { interviewsResult: { $size: 0 } }
    ]

    switch (filter.res) {
      case '採用':
        find.interviewsResult = { $in: ['採用', '社員採用'] }
        find.$or = notDec
        break;
      case '不採用':
        find.interviewsResult = { $in: ['不採用', '社員不採用'] }
        find.$or = notDec
        break;
      case '未定':
        find.$and = [
          { $or: notRes },
          { $or: notDec }
        ]
        break;
      case '辞退':
        // 辞退は declineReason があるもの
        find.declineReason = { $nin: [null, ''] }
        break;

      default:
        break;
    }
  }

  // 性別
  if (filter.sex && filter.sex !== '男女') {
    find.interviewsSex = filter.sex
  }

  // 対象者
  if (filter.name) {
    if (!find.$and) {
      find.$and = []
    }
    find.$and = find.$and.concat(spaceAndSearch(filter.name, 'interviewsName'))
  }

  // 面接官
  if (filter.interviewer) {
    if (!find.$and) {
      find.$and = []
    }
    find.$and = find.$and.concat(spaceAndSearch(filter.interviewer, 'interviewer'))
  }

  // 部署
  if (filter.dep && filter.title !== '清掃員') {
    find.interviewsDepartmentId = filter.dep
  }

  // ソート
  const sort = { 'createDate': -1, requestNo: -1 }
  // 取得件数
  const limit = perPage
  // 何ページ目か
  const skip = (page - 1) * perPage
  // 取得フィールド
  const project = {
    type: 1,
    category: 1,
    createDate: 1,
    requestNo: 1,
    status: 1,
    toStaffName: 1,
    interviewsDepartmentId: 1,
    interviewsRegularStaff: 1,
    interviewsResult: 1,
    firstInterviewRes: 1,
    interviewer: 1,
    interviewsName: 1,
    interviewsSex: 1,
    declineReason: 1,
    newGrad: 1,
    interviewsAppliedWorkLocationAddress: 1
  }

  try {
    const responseData = await context.$pigeon.findTasksBySkip(find, project, sort, limit, skip) || {}
    if (responseData.error) {
      alert('エラー発生\n' + responseData.msg)
      return
    }
    const list = responseData.list || []
    const total = responseData.total || 0

    const res = []

    // サブタスクjoin、データ成型
    for (let i = 0; i < list.length; i++) {
      const main = list[i]

      if (main.newGrad && main.declineReason) {
        main.res = '辞退'
        main.resColor = 'color:red !important;'

      } else if (main.interviewsResult && main.interviewsResult.length) {
        main.res = main.interviewsResult[0].replace('社員', '')
        if (main.res === '採用') {
          main.resColor = 'background-color:rgb(69 166 167) !important;'
        } else if (main.res.indexOf('不採用') > -1) {
          main.resColor = 'background-color:#b3aeae !important;'
        }
      } else if (main.newGrad && main.firstInterviewRes) {
        main.res = main.firstInterviewRes
        if (main.res.indexOf('不合格') > -1) {
          main.resColor = 'background-color:#b3aeae !important;'
        } else {
          main.resColor = 'background-color:#e5a94b !important;'
        }
      } else {
        main.res = '---'
        main.resColor = 'color:gray !important;'
      }

      if (main.interviewsSex) {
        main.sex = main.interviewsSex[0]
        if (main.sex === '男性') {
          main.sexColor = 'color:blue !important;'
        } else if (main.sex === '女性') {
          main.sexColor = 'color:#d53d57 !important;'
        }
      }

      // ステータス、編集、仮登録、依頼登録
      if (main.status == 'open') {
        main.statusText = '未完了'
      } else if (main.status == 'done') {
        main.statusText = '完了済'
      }

      res.push(main)
    }

    return { list: res, total }
  } catch (error) {
    console.log('面接一覧取得 error !!!')
    console.log(error)
    alert('エラーが発生しました。\r\n' + error)
    return []
  }
}

/**
 * 新卒面接集計
 * @param {*} context
 * @param {*} filter
 */
export async function getNewGradList(context, filter) {
  try {
    const find = {
      status: { $ne: 'remove' },
      type: MAIN_TYPE,
      category: CATEGORY_NAME,
      interviewsRegularStaff: true,
      newGrad: true
    }

    if (filter && (filter.start || filter.end)) {
      find.createDate = {}
      if (filter.start) {
        find.createDate.$gte = filter.start
      }
      if (filter.end) {
        // 時分秒がないため1日加算
        const end = moment(filter.end).add(1, 'days').format('YYYY-MM-DD')
        find.createDate.$lt = end
      }
    }

    const sort = { createDate: 1 }

    const res = await context.$pigeon.findTasks(find, ITEM, sort)

    if (res && res.length) return setData(filter, res)

    return null
  } catch (error) {
    alert('エラーが発生しました。\r\n' + error)
    return null
  }
}

/**
 * グラフにデータをセット
 * @param {*} filter 検索
 * @param {*} list データ
 * @returns
 */
function setData(filter, list) {
  // 円グラフ男性、女性の人数
  let man = 0
  let woman = 0

  // 折れ線グラフのラベル
  const month = setLabels(filter, list)
  const manApply = {}
  const manPass = {}
  const womanApply = {}
  const womanPass = {}

  // 辞退
  const decline = []
  const dec = {}

  for (let i = 0; i < list.length; i++) {
    const row = list[i]
    let res = ''
    if (row.interviewsResult && row.interviewsResult[0]) {
      res = row.interviewsResult[0]
    }

    if (row.interviewsSex && row.interviewsSex[0]) {
      const day = moment(row.createDate).format('YYYY-MM')

      // 辞退者
      if (row.declineReason) {
        const daySt = moment(row.createDate).format('YYYY年MM月')
        if (!dec[daySt]) {
          dec[daySt] = { num: 0, text: [] }
        }
        dec[daySt].num++
        dec[daySt].text.push(row.declineReason)

        // 採否決定後
        // if (res) {
        //   if (!dec[daySt][res]) {
        //     dec[daySt][res] = 0
        //   }
        //   dec[daySt][res]++

        // // 一次通過後
        // } else if (row.firstInterviewRes) {
        //   if (!dec[daySt][row.firstInterviewRes]) {
        //     dec[daySt][row.firstInterviewRes] = 0
        //   }
        //   dec[daySt][row.firstInterviewRes]++
        // } else {
        //   if (!dec[daySt]['一次未決']) {
        //     dec[daySt]['一次未決'] = 0
        //   }
        //   dec[daySt]['一次未決']++
        // }
      }

      if (!manApply[day]) manApply[day] = 0
      if (!manPass[day]) manPass[day] = 0
      if (!womanApply[day]) womanApply[day] = 0
      if (!womanPass[day]) womanPass[day] = 0

      // 男性
      if (row.interviewsSex[0] === '男性') {
        man++
        manApply[day]++
        if (res === '社員採用' && !row.declineReason) {
          manPass[day]++
        }

      // 女性
      } else {
        woman++
        womanApply[day]++
        if (res === '社員採用' && !row.declineReason) {
          womanPass[day]++
        }
      }
    }
  }

  // 円グラフ
  const pieData = {
    labels: ['男性', '女性'],
    datasets: [
      {
        data: [man, woman],
        backgroundColor: ['#4f81bd', '#f06292']
      }
    ]
  }

  // 棒グラフ
  const lineData = formatData(month, manApply, manPass, womanApply, womanPass)

  // 辞退
  if (dec) {
    for (let i = 0; i < Object.keys(dec).length; i++) {
      const d = Object.keys(dec)[i]
      decline.push({ ...dec[d], month: d, text: dec[d].text.sort() })
    }
  }

  return { pieData, lineData, decline }
}

/**
 * 棒グラフラベル生成
 * @param {*} filter 検索
 * @param {*} list データ
 * @returns
 */
function setLabels(filter, list) {
  let start = list[0].createDate
  let end = list[list.length - 1].createDate

  if (filter.start) {
    start = filter.start
  }
  if (filter.end) {
    end = filter.end
  }

  // グラフのラベル
  const labels = []
  // データ集計に使うキー
  const values = []

  let current = moment(start).startOf('month')
  const last = moment(end).endOf('month')

  while (current.isSameOrBefore(last)) {
    labels.push(current.format('YYYY年M月'))
    values.push(current.format('YYYY-MM'))

    current.add(1, 'month')
  }

  return { labels, values }
}

/**
 * 棒グラフデータを成型
 * @param {*} month ラベル値
 * @param {*} manApply 男性応募
 * @param {*} manPass 男性採用
 * @param {*} womanApply 女性応募
 * @param {*} womanPass 女性採用
 * @returns
 */
function formatData(month, manApply, manPass, womanApply, womanPass) {
  const ma = []
  const mp = []
  const wa = []
  const wp = []

  for (let i = 0; i < month.values.length; i++) {
    const m = month.values[i]
    ma.push(manApply[m] || 0)
    mp.push(manPass[m] || 0)
    wa.push(womanApply[m] || 0)
    wp.push(womanPass[m] || 0)
  }

  return {
    labels: month.labels,
    datasets: [
      {
        label: '応募 （男性）　',
        data: ma, // ← 人数
        borderColor: '#6baed6',
        backgroundColor: '#6baed6',
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
        fill: false
      },
      {
        label: '応募 （女性）　',
        data: wa,
        borderColor: '#f28cb1',
        backgroundColor: '#f28cb1',
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
        fill: false
      },
      {
        label: '採用 （男性）　',
        data: mp,
        borderColor: '#08519c',
        backgroundColor: '#08519c',
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
        fill: false
      },
      {
        label: '採用 （女性）　',
        data: wp,
        borderColor: '#d81b60',
        backgroundColor: '#d81b60',
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
        fill: false
      }
    ]
  }
}

/**
 * スペースがある場合、AND検索にする
 * @param {*} val
 * @returns
 */
function spaceAndSearch(val, field) {
  const words = val.trim().split(/\s+/)

  return words.map(w => ({
    [field]: { $regex: escapeRegex(w), $options: 'i' }
  }))
}

/**
 * 正規表現エスケープ
 * @param {*} str
 * @returns
 */
function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
